import styled from "styled-components";

export const Wrapper = styled.div`
  display: inline-block;
  width: fit-content;
  position: relative;
  border-radius: 5px;

  & > span.valid-error {
    position: absolute;
    top: 100%;
    left: 5px;
    font-size: 12px;
    color: #ff4040;
    padding: 2px 0;
    z-index: 1;
  }

  & input,
  & textarea,
  & .select {
    ${({ $isError }) => $isError && `border: 1px solid #ff4040 !important;`}
  }
`;
